// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__Rn6xY","loaderOuter":"PageOverlayLoader_loaderOuter__2ZR0M"};